import { Injectable } from '@angular/core';
import { BarList, BarLists } from '../models/bar-list.model';
import { ApiService } from './api.service';
import { Pair } from '../models/pair.model';


@Injectable({
  providedIn: 'root'
})
export class BarListService {

  constructor(
    private apiService: ApiService
  ) { }

  // Método encargado de recuperar el detalle de una lista
  getBarList(listId: string): Promise<BarList> {
    const url = `list/public/${listId}`;
    return this.apiService.doGet(url, undefined);
  }

  // Método para buscar listas de bares
  findBarLists(query: string): Promise<BarLists> {
    const url = `list/find`;
    const queryParams: Pair[] = [{key: 'query', value: query}];  
    return this.apiService.doGet(url, queryParams);
  }

}
